/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_HeadlineInputs */

const en_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, for the curious learner in you`)
};

const de_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader – für alle, die gerne dazulernen`)
};

const zh_tw_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader，獻給愛學習的你`)
};

const zh_cn_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader，献给爱学习的你`)
};

const es_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, para ti que amas aprender`)
};

const fr_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, pour toi qui aimes apprendre`)
};

const it_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, per te che ami imparare`)
};

const pt_br_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, feito pra quem ama aprender`)
};

const ja_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader、学ぶのが好きなあなたへ`)
};

const ko_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, 배움을 좋아하는 당신에게`)
};

const ru_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader — для тех, кто любит учиться`)
};

const th_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader สำหรับคนรักการเรียนรู้อย่างคุณ`)
};

const tr_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader, öğrenmeyi seven sana`)
};

const ar_closing_headline = /** @type {(inputs: Closing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vibe Reader، هدية لكل محبّ للتعلّم`)
};

/**
* | output |
* | --- |
* | "Vibe Reader, for the curious learner in you" |
*
* @param {Closing_HeadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_headline = /** @type {((inputs?: Closing_HeadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_HeadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_headline(inputs)
	if (locale === "de") return de_closing_headline(inputs)
	if (locale === "zh_tw") return zh_tw_closing_headline(inputs)
	if (locale === "zh_cn") return zh_cn_closing_headline(inputs)
	if (locale === "es") return es_closing_headline(inputs)
	if (locale === "fr") return fr_closing_headline(inputs)
	if (locale === "it") return it_closing_headline(inputs)
	if (locale === "pt_br") return pt_br_closing_headline(inputs)
	if (locale === "ja") return ja_closing_headline(inputs)
	if (locale === "ko") return ko_closing_headline(inputs)
	if (locale === "ru") return ru_closing_headline(inputs)
	if (locale === "th") return th_closing_headline(inputs)
	if (locale === "tr") return tr_closing_headline(inputs)
	return ar_closing_headline(inputs)
});